import React from "react";
import FAQContent from "../function-components/FAQContent";

function Faq() {
  return (
    <>
      <FAQContent />
    </>
  );
}

export default Faq;
